import React from "react";
import {useSelector} from "react-redux";
import PageHeaderButton from "../components/page-header-button";
import {OperationsOverview} from "../operations";
import AdminAccessDenied from "../../system/components/admin-access-denied";
import {ADMIN_PERMISSIONS, hasAdminPermission} from "../../system/admin-access";

function Dashboard() {
    const user = useSelector((state) => state.auth.user);
    if (!hasAdminPermission(user, ADMIN_PERMISSIONS.DASHBOARD_VIEW)) {
        return <AdminAccessDenied/>;
    }
    return (
        <div className="w-full p-3 flex flex-column gap-3 rtl text-xs">
            <PageHeaderButton
                title="operations-dashboard-title"
                description="operations-dashboard-description"
            />
            <OperationsOverview embedded/>
        </div>
    );
}

export default Dashboard;
